import React, { useState } from 'react'
import { BoardEntity, HttpMethod } from '../../model'
import { httpClient } from '../../service'
import { Form } from 'react-bootstrap'

const Withdrawal = (props: any) => {
    const match = props.match;

    const queryParams = new URLSearchParams(props.location.search);
    const lang = queryParams.get('lang');

    const subTitle = lang === 'en' ? 'We always strive to provide the best service.' : '항상 최선의 서비스를 드리기 위해 노력합니다.';
    const memberId = lang === 'en' ? 'MemberId' : '회원번호';
    const feedbackMsg = lang === 'en' ? 'This item is required' : '이 항목은 필수항목입니다.';
    const emailTitle = lang === 'en' ? 'email' : '연락처 또는 이메일';
    const subjectTitle = lang === 'en' ? 'subject' : '제목';
    const placeHolderInfo = lang === 'en' ? 'Reasons for withdrawal' : '탈퇴 사유';
    const subjectInfo = lang === 'en' ? 'Inquiry about withdrawal of membership' : '회원탈퇴 문의';
    const contentText = lang === 'en' ? 'Please fill out the form below.\n\nEmail: \nReasons for withdrawal: ' : '아래 양식에 맞춰 작성 해 주세요.\n\n이메일: \n탈퇴사유:';

    const forumCode = 'withdraw';
    const [validated, setValidated] = useState(false);
    const [model, setModel] = useState<BoardEntity>({ forumCode: forumCode, subject: '회원탈퇴 문의', content: subjectInfo});
    const [submitting, setSubmitting] = useState(false);
    const placeHolderText = lang === 'en' ? 'Please make sure to check your contact information and fill it out.' : '연락처를 반드시 확인 후 작성 해 주세요.';

    const submitForm = async (e: any) => {
        const isValid = e.currentTarget.checkValidity()
        if (!isValid) {
            e.preventDefault()
            e.stopPropagation()
            setValidated(true)
            return false
        }
        e.preventDefault()
        const form = e.target
        setSubmitting(true)
        console.log(`form state=${JSON.stringify(model)}`)
        const url = 'boards/withdrawal'
        let option = {
            url: url,
            method: HttpMethod.POST,
            body: model,

        }
        if(lang !== null || lang !== 'ko'){
            console.log("aaaaa");
            // option.headers.set(`Accept-Language`, lang!);
            const langParam = {'lang': lang!};
            option = {...option, ...langParam};
        }

        console.log(option);

        const act = await httpClient(option)
        setSubmitting(false)

        if (act.result) {
            const msg = lang === 'en' ? 'The member\'s resignation was normally received.' : '회원탈퇴 문의가 정상적으로 접수되었습니다.';
            alert(msg);
            const data: BoardEntity = { writer: '', tel: '', content: '', subject: subjectInfo };
            setModel(data);
            form.reset();
        } else {
            alert(`오류:${act.errorMsg}`)
        }
    }
    const handleInputChange = (e: any) => {
        console.log(`name=${e.target.name}, value=${e.target.value}`)
        const data = { ...model, [e.target.name]: e.target.value }
        setModel(data)
    }

    return (
        <div className='bloc l-bloc' id='bloc-0'>
            <div className='container bloc-sm'>
                <div className='row'>
                    <div className='col-lg-6 offset-lg-3 offset-md-2 col-md-8'>
                        <Form data-form-type='blocs-form' noValidate validated={validated}
                              onSubmit={submitForm}>
                            <h6 className='mg-md subtitle'>{subTitle}<br /></h6>
                            <Form.Group>
                                <Form.Label className='form-label'>{memberId}&nbsp;*</Form.Label>
                                <Form.Control name='writer' required onChange={handleInputChange} />
                                <Form.Control.Feedback type='invalid'>{feedbackMsg}</Form.Control.Feedback>
                            </Form.Group>
                            {/*<Form.Group>*/}
                            {/*    <Form.Label className='form-label'>{emailTitle}&nbsp;*</Form.Label>*/}
                            {/*    <Form.Control name='tel' required onChange={handleInputChange}/>*/}
                            {/*    <Form.Control.Feedback type='invalid'>{feedbackMsg}</Form.Control.Feedback>*/}
                            {/*</Form.Group>*/}
                            <Form.Group>
                                <Form.Label className='form-label'>{subjectTitle}</Form.Label>
                                <Form.Control value={subjectInfo}  readOnly={true}/>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>{placeHolderInfo} *</Form.Label>
                                <Form.Control as='textarea' onChange={handleInputChange} rows={4} cols={50} required
                                              name='content' defaultValue={contentText}></Form.Control>
                            </Form.Group>
                            <button type='submit'
                                    className='bloc-button btn btn-d btn-lg btn-block download-bt'
                                    disabled={submitting}
                            >{submitting ? '전송중..' : '문의하기'}
                            </button>
                            {/*<TermsModal />*/}
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Withdrawal
